import React from 'react';
import { useApp } from '../../core/AppContext';

export default function BenchmarkingView() {
  useApp();
  return (
    <div style={{ backgroundColor: '#fff', borderRadius: '8px', padding: '40px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)', marginTop: '10px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '20px' }}>
        <div style={{ fontSize: '40px' }}>📊</div>
        <div>
          <h2 style={{ color: '#0f2027', margin: 0 }}>EEA Benchmarking Platform</h2>
          <p style={{ color: '#718096', margin: '4px 0 0 0', fontSize: '14px' }}>Unified interface to benchmark frontier or self-hosted LLMs against internal SLA criteria.</p>
        </div>
      </div>
      <div style={{ backgroundColor: '#fff3cd', borderLeft: '4px solid #ffc107', padding: '15px', borderRadius: '4px', marginBottom: '20px', fontSize: '13px', color: '#856404' }}>
        <strong>🚧 Phase 2 Feature:</strong> High-throughput evaluation runner covering DS1000, BFCL tool calling, MT-Bench, and CRAG RAG metrics.
      </div>
    </div>
  );
}
